import { Layout, Input, message, Table, ConfigProvider, Row, Col, Popconfirm, Statistic, Pagination, Button, Popover} from 'antd';
import { Content } from 'antd/lib/layout/layout';
import zhCN from 'antd/lib/locale/zh_CN';
import OAMSider from '../oam-sider';
import React, {useEffect, useRef, useState} from "react";
import {sendHttpPostRequest} from "../../../api/http-request";
import Cookies from 'js-cookie';
import idataCourseTableStyles from "../../common/global-styles/idatacourse-table.module.less";
import UserCard from '../user/oam-userinfo-card';
import { BACKEND_API_URL } from '../../../constants/constants'

const { Search } = Input;

export interface Props {}


export const OAMTestList: React.FC<Props> = (props) => {
    const [testResult, setTestResult] = useState([] as any[]);  // 当前显示的结果页
    const [resultSum, setResultSum] = useState(0);  // 搜索返回的结果数
    const [totalCount, setTotalCount] = useState(0);  // 搜索返回的结果数
    const queryContent = useRef('');  // 记录搜索串
    const order = useRef('');  // 排序升序降序
    const order_by = useRef('');  // 排序列
    const page = useRef(1);  // 记录当前的页数
    const pageSize = useRef(10);  // 记录当前每页展示数量

    useEffect(()=> {
        queryTestList();
      },[])
  
  
    const queryTestList = () => {      
      sendHttpPostRequest(
        'homework/api/oam_query_homework_list/',
        {
            sessionid: Cookies.get("sessionid"),
            query: queryContent.current,
            page: page.current,
            pagesize: pageSize.current,
            order: order.current,
            order_by: order_by.current,
            //source: querySource.current,
        },
        (response:any) => {
          message.destroy();
          if (response.code == -100) {
              // 没登录
              window.location.href = '/oam_login?next=oam_test_list';
          } else if (response.code == -501) {
              // 没权限
              window.location.href = '/oam_login?next=oam_test_list';
          } else if (response.is_ok == true) {
              setTestResult(response.query_list);
              setResultSum(response.total_sum);
              setTotalCount(response.total_count);
          }
      }
    )
    
  }
  

    /** 删除作业 */
    const deleteTest = (homeworkId:any) => {
      sendHttpPostRequest(
        'homework/api/oam_delete_homework/',
        {
            sessionid: Cookies.get("sessionid"),
            homework_id: homeworkId,
        },
        (response:any) => {
          message.destroy();
          if (response.code == -100) {
              // 没登录
              window.location.href = '/oam_login?next=oam_test_list';
          } else if (response.code == -501) {
              // 没权限
              window.location.href = '/oam_login?next=oam_test_list';
          } else if (response.is_ok == true) {
              queryTestList();
          }else{
            message.error("删除作业失败~");
          }
      }
    )
    
  }
    

     
      // 渲染操作
      const renderActions = (text:any, record:any) => {
          return <Row align='middle' justify='center' gutter={[16,8]}> 
                  <Col> 
                      <Popconfirm placement="top" title={'确认删除作业"' + record.name + '"吗？'} onConfirm={()=>{deleteTest(record.id)}} okText="确认" cancelText="取消">
                            <Button
                                style={{borderRadius:20,fontSize:14}}
                                size='small'
                                id="deleteexe"
                                type="dashed"
                                danger
                            > 删除
                            </Button>
                      </Popconfirm>
                  </Col>
                 
                       
          </Row>
      }
  
      const renderName = (text:any, record:any) => {
          if (text.length > 50) {
            return <>
              {record.name.slice(0,50) + '...'}
            </>
          } else {
            return <>
              {record.name}
            </>
          }
        }
      const testCols :any= [
        {
          title:'ID',
          dataIndex: 'id',
          key: 'id',
          align: 'left',
          width: 50,
          ellipsis: true,
        },
        {
          title: '作业',
          dataIndex: 'name',
          key: 'name',
          align: 'left',
          width: 100,
          ellipsis: true,
          render:renderName,
        },
        
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          align: 'center',
          width: 80,  
          ellipsis: true,
        },
        {
          title: '截止时间',
          dataIndex: 'submit_time',
          key: 'submit_time',
          align: 'center',
          width: 180,
          ellipsis: true,
          render: (text: any, record: any) => (
            <div>{text?.slice(0,16)}</div>
          )
        },
        {
            title: "教师",
            dataIndex: "teacher",
            key: "teacher",
            width: 150,
            ellipsis: true,
            align: 'left',
            render: (text: any, record: any) =>
            {

                return (
                  <Row align="middle" justify="start" wrap={false}>
                    <Col flex="40px">
                      <Popover
                        arrowPointAtCenter={true}
                        trigger="hover"
                        placement="left"
                        content={<UserCard user_id={record?.teacher_id} />}
                        title={null}
                      >
                        <img
                          onMouseOver={() => {}}
                          style={{
                            width: 30,
                            height: 30,
                            borderRadius: 15,
                            cursor: 'pointer',
                          }}
                          src={record?.teacher_avatar?.startsWith('http') ? record?.teacher_avatar : BACKEND_API_URL + record?.teacher_avatar}
                        />
                      </Popover>
                    </Col>
                    <Col flex="80px">
                      <span>{record.teacher_real_name == '' ? record.teacher : record.teacher_real_name}</span>
                    </Col>
                  </Row>
                )   
            },
        },
        {
            title: "所属课程",
            dataIndex: "course_name",
            key: "course_name",
            width: 120,
            align: 'left',
            ellipsis: true,
        },
        {
            title: "所属机构",
            dataIndex: "college_name",
            key: "college_name",
            width: 120,
            ellipsis: true,
            align: 'left',
        },
        {
          title: "操作",
          dataIndex: "actions",
          key: "actions",
          width: 80,
          ellipsis: true,
          align: 'center',
          fixed: 'right',
          render: renderActions,
      },
      ]

          //页码和页数发生了变化
    const onPageChange = (newPage: number, newPageSize?: number | undefined) => {
        page.current = newPage ? newPage : 1;
        if (newPageSize) {
            pageSize.current = newPageSize;
        }
        queryTestList();
    }

    //点击了搜索按钮
    const onSearchBtn = (value: string) => {
        page.current = 1;
        queryContent.current = value;
        queryTestList();
    }



    return (
             
        <Layout style={{ minHeight: '100vh',minWidth:1200 }}>
            <OAMSider keys={['6']}  openKeys={[]} />
            <Layout style={{backgroundColor:'#f9f9f9'}}>
                <Content style={{ backgroundColor:'#fff',borderRadius:5,minWidth:400,margin:30 ,paddingTop:20}}>
                  <div style={{paddingLeft: 30, paddingRight: 30, paddingBottom: 30}}>
                        <Row align="middle"  gutter={16} >
                            <Col flex='120px'>
                                <Statistic title="总作业" value={totalCount} />
                            </Col>

                            <Col flex='250px'>
                                <Search
                                    placeholder="搜索作业"
                                    style={{ width: 350 }}
                                    enterButton={true}
                                    onSearch={onSearchBtn}
                                    className={idataCourseTableStyles.oamSearch}
                                />
                            </Col>
                        </Row>

                        <div style={{minHeight:500}}  className={idataCourseTableStyles.tableWrapper}>
                            <ConfigProvider locale={zhCN}>
                                <Table
                                    dataSource={testResult}
                                    columns={testCols}
                                    rowKey={record => record.id}
                                    pagination={false}
                                    scroll={{ x: 800 }}
                                />
                            </ConfigProvider>
                        </div>
                            

                        <ConfigProvider locale={zhCN}>
                            <div style={{marginTop:20, marginBottom:30}} className={"css.pagination"} >
                                <Pagination
                                    total={resultSum}
                                    pageSize={pageSize.current}
                                    defaultPageSize={10}
                                    hideOnSinglePage={true}
                                    current={page.current}
                                    onChange={onPageChange}
                                    showQuickJumper={true}
                                    showSizeChanger={false}
                                    showTotal={total => `共 ${total} 作业`}
                                    //pageSizeOptions={["10","20","50","100"]}
                                />
                            </div>
                        </ConfigProvider>
                    </div>
                </Content>
            </Layout>
            
        </Layout>

    )

}

export default OAMTestList

